import { render, staticRenderFns } from "./VATRecoverabilitySearch.vue?vue&type=template&id=9fe6416e&scoped=true"
import script from "./VATRecoverabilitySearch.vue?vue&type=script&lang=ts"
export * from "./VATRecoverabilitySearch.vue?vue&type=script&lang=ts"
import style0 from "./VATRecoverabilitySearch.vue?vue&type=style&index=0&id=9fe6416e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe6416e",
  null
  
)

export default component.exports